export default __webpack_public_path__ + "static/media/CardPage.5af97bb2.svg";